var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      on: {
        click: function($event) {
          return _vm.$emit("change", _vm.variant)
        }
      }
    },
    [
      _c(
        "button",
        {
          staticClass:
            "relative brdr-cl-bg-tertiary brdr-1 bg-cl-transparent mr10 pointer price-selector",
          class: { active: _vm.isActive },
          attrs: {
            "aria-label": _vm.$t("Price {variant}", {
              variant: _vm.variant.label
            })
          }
        },
        [_c("span", { staticClass: "bg-cl-transparent absolute block square" })]
      ),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.variant.label))])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }